/**
 * ______                       ___  _____
 * | ___ \                     |_  |/  ___|
 * | |_/ /__ _   __ _   ___      | |\ `--.
 * |  __// _` | / _` | / _ \     | | `--. \
 * | |  | (_| || (_| ||  __/ /\__/ //\__/ /
 * \_|   \__,_| \__, | \___| \____/ \____/
 *               __/ |
 *              |___/
 *
 */

// Encoding: UTF-8
var spinner 	='<div class="spinner mx-auto"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div><div class="rect6"></div><div class="rect7"></div><div class="rect8"></div><div class="rect9"></div><div class="rect10"></div></div>';
$(document).ready(function () {

	if (typeof request_typeahead_string !== 'undefined' && typeof active_page_id !== 'undefined' && typeof typeahead_language !== 'undefined') {
		load_typeahead(request_typeahead_string,active_page_id,typeahead_language);
	}

	/********************************************/
	/*				Externe Links				*/
	/********************************************/
	// Für Target_blank HTML-konform
	$("area.external, a[rel=external]").attr("target", "_blank");
	$("a[rel=top]").attr("target", "_top");
	$("a[rel=self]").attr("target", "_self");
	$("a[target=_blank]").attr("rel", function(i, val) {
		return val + " external noopener";
	});

	/********************************************/
	/*		Threshold for lazy-loading			*/
	/*			is device-height				*/
	/********************************************/
	var lazy_threshold		= window.innerHeight;
	$("img[data-src]").unveil(lazy_threshold);

	// Anchor-Links
	$(".anchor-link").click(function (event) {
		event.preventDefault();
		var data_target		= $(this).attr("data-target");
		var target			= $("#" + data_target);
		init_scroll(target);
		// return false;
	});

	// Moodbar - slick
	$(".moodbar-content").slick({
		slidesToShow:	1,
		slidesToScroll:	1,
		adaptiveHeight:	true,
		autoplay:		true,
		autoplaySpeed:	8000,
		lazyLoad:		'ondemand',
		arrows:			true,
		dots:			true,
		mobileFirst:	true,
	});

	toggle_person_bio();
	toggle_text_image();
	load_youtube();
	init_navi();
	init_mobile_navi_click();
	init_addthis();

	$(".toggle-mobile-menu").click(function() {
		$(".navbar-mobile").show();
		$(".no-click-wrapper-mobile").show();
	});

	//Adventskalender2020
	$( ".adventskalender-kachel.unlocked" ).click(function() {
		$(`#${$(this).attr("id")} .adventskalender2020-animation`).fadeIn(2000);
		var link = $(this).attr("data-link");
		setTimeout(function() {
			go_to_site(link);
		}, 1000);
	})


	/********************************************/
	/*			To Top Button					*/
	/********************************************/
	$(window).bind("scroll", function () {
		// if ($(window).width() <= 991) {
		// 	var a			= $(".navbar-light.navbar-expand-lg").height();
		// } else {
		// 	var a			= $(".navbar-default.navbar-expand-lg").height();
		// }

		// check for banner-container and add height.
		// var delta_lb	= ($("#leaderboard-container").outerHeight() !== null && $("#leaderboard-container").outerHeight() > 0) ? $("#leaderboard-container").outerHeight() : 0;
		var scroll_threshold = $("#header").height() + $(".navbar-wrapper").height();

		if ($(window).scrollTop() > scroll_threshold) {
			$("#sticky-nav").addClass("d-block");
			$("#sticky-nav").removeClass("d-none");
			// if ($(window).width() > 1199) {
			$(".to-top-button").show();
			// }
		} else {
			$("#sticky-nav").addClass("d-none");
			$("#sticky-nav").removeClass("d-block");
			// if ($(window).width() > 1199) {
			$(".to-top-button").hide();
			// }
		}
	});

	// slowly scrolling to the top of the page
	$(".to-top-button").click(function (e) {
		$("html, body").animate({
			scrollTop	: $("#header").offset().top
		}, "slow");
		e.preventDefault();
	});
	/********************************************/

	if (scroll_comment_section != "") {
		init_scroll(scroll_comment_section);
		var stateObj					= {info: "neuer Chronik Eintrag"};
		history.pushState(stateObj, "test", "?comment_sent=true");
	}

	if (scroll_rating_section != "") {
		init_scroll(scroll_rating_section, 150);
		var stateObj					= {info: "neuer Chronik Eintrag"};
		history.pushState(stateObj, "test", "?rating_sent=true");
	}

	$("#toc-button").click(function(){
		$(".toc-wrapper").toggleClass("d-none");
	});
	$("#toc-close").click(function(){
		$(".toc-wrapper").toggleClass("d-none");
	});

	let comment_count = 5;
	$("#display_comments").on("click", "#comment_load_more", function () {
		$("#comment_load_more").html(spinner);
		comment_count += 50;
		$('#display_comments').load(`${window.location.origin}/${$("#comment_load_more").attr("target")}&count=${comment_count}&showerror`, {
			comment_count: comment_count
		});
	});

	init_comment_functions();

	set_rating($('#rating_avg').text());

	/********************************************/
	/*			CookieManager					*/
	/********************************************/
	// add click-Event to the Cookie-Change-Link that opens the dialog of the cookiemanager
	$("#change_cookie_settings").on('click',function(e) {
		e.preventDefault();
		cookiemanager.show_dialog();
	});
});

/**
 * lazy load after every ajax request
 * */
$(document).ajaxComplete(function(event,request, settings ) {
	// Threshold for lazy-loading is device-height
	var lazy_threshold		= window.innerHeight;
	$("img[data-src]").unveil(lazy_threshold);
	if (request.status == 200) {
		load_youtube();
	}
	// re-init comment-functions on load-more
	init_comment_functions();
});

function set_rating(rating) {
	$(".rating_display").starRating({
		initialRating	: rating,
		strokeWidth		: 10,
		starSize		: 25,
		strokeColor		: '#894A00',
		useFullStars	: true,
		readOnly		: false,
		callback		: function(current_rating, $el) {
			let form	= $el.closest(".ratingbox").find("form");
			form.find('input[name="rating"]').each(function(){
				if ($(this).val() == current_rating) {
					this.checked = true;
				}
			});
			form.find('button[name="submit_rating"]').click();
		}
	});
}

function go_to_site(href) {
	window.location.href = href;
}

function toggle_person_bio() {
	$(".person-toggle").click(function (event) {
		$(this).toggleClass("fa-chevron-down fa-chevron-up");
		$(this).closest(".person-right").find(".person-bio").toggleClass("d-none");
	});
}

function toggle_text_image() {
	$(".langtext-more-link").click(function() {
		var body		= $(this).closest(".full-container").find(".langtext-content");
		var link_show	= $(this).closest(".full-container").find(".langtext-more-link");
		$(body).removeClass('d-none');
		$(link_show).addClass("d-none");
	});
}

function load_youtube() {
	$('.m_overlay').click(function (e) {
		e.preventDefault();
		var th				= $(this);
		var embed_url		= th.data('src');
		var width			= th.parent().parent().width();
		var height			= th.parent().parent().height();
		var iframe			= '<div class="col-12"><div class="embed-responsive embed-responsive-16by9 mb-4"><iframe allowfullscreen="" src="' + embed_url + '" width="' + width + '" height="' + height + '"></iframe></div></div>';
		th.parent().parent().html(iframe);
	});
}

function delete_cookie(name) {
	document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function set_cookie(name, value, days) {
	var expires = "";
	if (days) {
	  var date = new Date();
	  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
	  expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

function get_cookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
	  var c = ca[i];
	  while (c.charAt(0) == ' ') c = c.substring(1, c.length);
	  if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

function init_comment_functions() {
	// Antwortbox anzeigen und cookie setzen
	$(".comment_answer").click(function () {
		let comment			= $(this).closest('.main-comment');
		console.log($(comment).attr('id'));
		// let comment_text	= $(comment).find(".comment_text").text();
		// let comment_author	= $(comment).find(".infos").find(".comment_name").text();
		// let comment_date	= $(comment).find(".infos").find(".comment_date").text();
		set_cookie('answer_id', $(comment).attr('id'), 1);
		// $("#answer_alert").find("li").text(`Sie antworten auf den Kommentar "${comment_text.trim()}" von ${comment_author} vom ${comment_date}`);
		// $("#answer_alert").css('display','block');

	});

	// Antwortbox entfernen und cookie entfernen
	$("#answer_cancel").click(function () {
		delete_cookie("answer_id");
		// $("#answer_alert").css('display','none');
	});

	// Alert bei Refresh richtig setzen
	if (get_cookie("answer_id") != null) {
		// let comment_id = get_cookie("answer_id");
		// let comment_text = $(`#${comment_id}`).children(".comment_text").text();
		// let comment_author = $(`#${comment_id}`).children(".infos").find(".comment_name").text();
		// let comment_date = $(`#${comment_id}`).children(".infos").find(".comment_date").text();
		// $("#answer_alert").find("li").text(`Sie antworten auf den Kommentar "${comment_text.trim()}" von ${comment_author} vom ${comment_date}`);
		// $("#answer_alert").css('display','block');
	}
}

function init_navi() {

	$(".navbar-mega-menu .row #menu_button").click(function() {
		$(".navbar-mobile").show();
		$(".no-click-wrapper-mobile").show();
	});

	// $(".btn-search").click(function() {
	// 	var b = $(this).closest("form").find("input").val();
	// 	if (b == undefined) {
	// 		b = $(this).prev().val();
	// 	}
	// 	if (b == "" || b == "Suche") {
	// 		alert("Bitte geben Sie einen Suchbegriff ein!");
	// 		return false;
	// 	}
	// 	return true;
	// });

	var timer = null;

	$('#nav-customer li.hover-enable > a').click(function(event) {
		var $this				= $(this);
		var tmp_link			= $(this).attr('href');
		var target_container	= $(this).attr('data-target');
		var offset_mega_menu	= $("#header").offset().top + $("#header").innerHeight() + $(".container-fluid.navbar-wrapper").innerHeight() + 2;

		// Check ob Mega Menu offen ist
		if ($("#"+target_container).find('.mega-menu-container').css('display') == "block") {
			if (tmp_link == "#") {
				event.preventDefault();
				return;
			} else {
				// execute url
				return;
			}
		} else {
			// alle schließen
			$('.mega-menu-container').hide();
		}
		event.preventDefault();
		// Mega Menü aufklappen
		if ($this.parent().has(".hover-enable")) {
			$("#"+target_container).find('.mega-menu-container').show();
			$("#"+target_container).find('.mega-menu-container').css("top",offset_mega_menu);
		}
	});

	// $('#sticky-nav li.hover-enable > a').click(function(event) {
	// 	var $this				= $(this);
	// 	var tmp_link			= $(this).attr('href');
	// 	var target_container	= $(this).attr('data-target');
	// 	var offset_mega_menu	= $(this).offset().top + $(this).innerHeight() + 6;
	// 	// Check ob Mega Menu offen ist
	// 	if ($("#"+target_container).find('.mega-menu-container').css('display') == "block") {
	// 		if (tmp_link == "#") {
	// 			event.preventDefault();
	// 			return;
	// 		} else {
	// 			$this.attr("href",tmp_link);
	// 			return;
	// 		}
	// 	} else {
	// 		// alle schließen
	// 		$('.mega-menu-container').hide();
	// 	}
	// 	event.preventDefault();
	// 	// Mega Menü aufklappen
	// 	if ($this.parent().has(".hover-enable")) {
	// 		$("#"+target_container).find('.mega-menu-container').show();
	// 		$("#"+target_container).find('.mega-menu-container').css("top",offset_mega_menu);
	// 	}
	// });

	// close button
	$('.close-mega-menu').click(function(){
		$('.mega-menu-container').hide();
	});

	// close onleave
	$('.mega-menu-container').mouseleave(function() {
		// clearTimeout(timer);
		$(".mega-menu-container").hide();
	});

}

function init_mobile_navi_click() {
	$(".button-expand-main").click(function() {
		var b = $(this);
		b.toggleClass("fa-chevron-up");
		b.toggleClass("fa-chevron-down");
		b.parent().next().toggle();
	});
	$(".button-expand-meta").click(function() {
		var b = $(this);
		b.toggleClass("fa-chevron-up");
		b.toggleClass("fa-chevron-down");
		b.parent().next().toggle();
	});
	$(".button-expand-meta").each(function(b) {
		var c = $(this);
		c.addClass("fa-chevron-down");
		c.parent().next().hide();
	});
	$(".navbar-mobile .button-close").click(function() {
		$(".navbar-mobile").hide();
		$(".no-click-wrapper-mobile").hide();
	});
	$(".no-click-wrapper-mobile").click(function() {
		$(".navbar-mobile").hide();
		$(".no-click-wrapper-mobile").hide();
	});
	$(".toggle-search").click(function() {
		$(this).closest(".th-wrap-cont").find("form").toggleClass("d-none");
	});
	$("#search_xs_sticky").click(function() {
		$("#search_xs-input").toggleClass("d-none");
	});
	// mobile navigation - prevent link if not necessary
	$('nav.navbar-mobile .main-category.expandable').click(function(event) {
		var $this				= $(this);
		var tmp_link			= $(this).attr('href');
		var main				= $this.closest(".main");
		var button				= main.find("button");
		// Check ob aufgeklappt ist
		if (button.hasClass('fa-chevron-down')) {
			// trigger('aufklappen')
			button.toggleClass("fa-chevron-up");
			button.toggleClass("fa-chevron-down");
			button.parent().next().toggle();
			event.preventDefault();
			return;
		} else {
			if (tmp_link == "#") {
				// trigger('zuklappen')
				button.toggleClass("fa-chevron-up");
				button.toggleClass("fa-chevron-down");
				button.parent().next().toggle();
				event.preventDefault();
				return;
			} else {
				// folge link
				$this.attr("href",tmp_link);
				return;
			}
		}
	});
}

function load_typeahead(th_string,p_id,lang) {
	init_typeahead('#sticky-search-meta',		th_string,	p_id, lang);
	init_typeahead('.search-xs',				th_string,	p_id, lang);
	init_typeahead('.sticky-search-xs',			th_string,	p_id, lang);
	init_typeahead('.search-meta',				th_string,	p_id, lang);
}

function init_typeahead(selector,string,id,language) {
	// default options
	var top				= 0;
	var right			= 0;
	var width			= 0;
	var page_id			= id;
	var defaultstring 	= string;
	var container		= "";
	var id_add			= "";

	switch(selector) {
		case '.search-xs':
			container_width	= $(selector).closest(".header-content").innerWidth();
			top				= "21px";
			right			= 0;
			container		= $(selector).closest(".th-wrap-cont").find(".typeahead-container-md");
			width 			= container_width;
			id_add			= "_xs";
			break;
		case '.sticky-search-xs':
			container_width	= $(selector).closest(".page").innerWidth();
			top				= "18px";
			right			= 0;
			container		= $(selector).closest(".th-wrap-cont").find(".typeahead-container-md");
			width 			= container_width;
			id_add			= "_sticky_xs";
			break;
		case '#sticky-search-meta':
			container_width	= $(selector).closest(".typeahead-container").innerWidth();
			top				= "58px";
			right			= 15;
			container		= ".typeahead-container-sticky";
			width 			= 360;
			id_add			= "_sticky";
			break;
		default:
			// check first form-group width and position
			container_width	= $(selector).closest(".typeahead-container").innerWidth();
			top				= "42px";
			right			= 15;
			container		= ".typeahead-container";
			width 			= container_width;
			id_add			= "_meta";
			break;
	}
	// get page_id and defaultstring
	$(selector).wh_typeahead({
		ajaxurl:		"/ajax/typeahead"
		,page_id:		page_id
		,top:			top
		,right:			right
		,container:		container
		,defaultstring:	defaultstring
		,id_add:		id_add
		,width:			width
		,sprache:		language
	});
}

function init_scroll(selector, add_threshold) {
	var delta_nav		= 40;
	var threshold		= 40;
	var scroll_th_add	= (typeof add_threshold === 'undefined') ? 0 : add_threshold;

	// unveil images prior to scroll-section
	$("img").trigger("unveil");
	window.setTimeout( function() {
		// scroll to given selector
		$("html, body").animate({
			scrollTop: $(selector).offset().top - delta_nav - threshold - scroll_th_add
		},"slow");
	}, 500 );

}

/********************************************/
/*			addThis							*/
/********************************************/
function init_addthis() {
	jQuery('.sharing.inactive').click(function(){
		if (cookiemanager.accepted_statistics) {
			var addthisScript = document.createElement('script');
			addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js##domready=1&pubid=ra-5ef590a6d66daf71');
			document.body.appendChild(addthisScript);
			$('.sharing.inactive').hide();
			$('.share-button').hide();
		} else {
			alert("Die Marketing-Cookies wurden verweigert, diese Funktion steht daher nicht zur Verfügung.");
		}
	});
}
